import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';
import { useToast } from '../components/ToastContext';
import { useConfirm } from '../components/ConfirmModal';
import { T } from '../styles/theme';

export default function GestioneEbay() {
  const [annunci, setAnnunci] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const toast = useToast();
  const { confirm, ConfirmDialog } = useConfirm();

  const load = () => {
    api.get('/annunci/ebay').then((r) => setAnnunci(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleUpdatePrice = async (itemId) => {
    const fd = new FormData();
    fd.append('prezzo', newPrice);
    try {
      await api.put(`/annunci/ebay/${itemId}/prezzo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Prezzo aggiornato');
      setEditingId(null); load();
    } catch { toast.error('Errore aggiornamento'); }
  };

  const handleEnd = async (itemId) => {
    const ok = await confirm('Terminare questo annuncio eBay?');
    if (!ok) return;
    try { await api.delete(`/annunci/ebay/${itemId}`); toast.success('Annuncio terminato'); load(); }
    catch { toast.error('Errore'); }
  };

  return (
    <Layout>

      {ConfirmDialog}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="page-title">Annunci eBay</h1>
            <p className="mt-1" style={{ color: T.muted }}>{annunci.length} annunci attivi</p>
          </div>
          <Link to="/annunci/crea" className="btn-primary text-sm">+ Crea Annuncio</Link>
        </div>

        {loading ? (
          <div className="text-center py-12" style={{ color: T.faint }}>Caricamento...</div>
        ) : annunci.length === 0 ? (
          <div className="card" style={{ padding: 48, textAlign: 'center' }}>
            <p className="text-lg mb-2" style={{ color: T.muted }}>Nessun annuncio attivo su eBay</p>
            <Link to="/annunci/crea" className="text-sm hover:underline" style={{ color: T.violet }}>Crea il tuo primo annuncio</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {annunci.map((a) => (
              <div key={a.item_id} className="card flex flex-col sm:flex-row items-start gap-4" style={{ padding: 20 }}>
                {a.foto_url && (
                  <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0" style={{ background: T.elem }}>
                    <img src={a.foto_url} alt="" className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-medium truncate" style={{ color: T.text }}>{a.titolo}</p>
                  <div className="flex flex-wrap gap-3 mt-2 text-sm">
                    {editingId === a.item_id ? (
                      <div className="flex gap-2 items-center">
                        <input type="number" step="0.01" value={newPrice} onChange={(e) => setNewPrice(e.target.value)}
                          className="input w-24 text-sm" style={{ borderColor: T.borderActive }} />
                        <button onClick={() => handleUpdatePrice(a.item_id)} className="text-xs hover:underline" style={{ color: T.green }}>Salva</button>
                        <button onClick={() => setEditingId(null)} className="text-xs hover:underline" style={{ color: T.faint }}>Annulla</button>
                      </div>
                    ) : (
                      <span className="font-bold cursor-pointer hover:underline" style={{ color: T.violet }} onClick={() => { setEditingId(a.item_id); setNewPrice(a.prezzo); }}>
                        €{parseFloat(a.prezzo || 0).toFixed(2)}
                      </span>
                    )}
                    <span className="flex items-center gap-1" style={{ color: T.muted }}>👁️ {a.visite}</span>
                    <span className="flex items-center gap-1" style={{ color: T.muted }}>⭐ {a.watcher}</span>
                  </div>
                </div>
                <div className="flex gap-2">
                  <a href={a.link} target="_blank" rel="noopener noreferrer"
                    className="btn-ghost text-xs">🔗 eBay</a>
                  <button onClick={() => { setEditingId(a.item_id); setNewPrice(a.prezzo); }}
                    className="btn-ghost text-xs">✏️ Prezzo</button>
                  <button onClick={() => handleEnd(a.item_id)}
                    className="btn-danger text-xs">🗑️ Termina</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>    </Layout>
  );
}
